module.exports = __webpack_public_path__ + "static/media/12-adresse.8c649412.mp3";